import {Route} from "@angular/router";
import {guardMeasureUnitsWatch} from "@/app/routes/guards/measure-units-guard";

const NAME = 'Единицы измерений'

export const measureUnits: Route[] = [
    {
        path: 'measureunits',
        loadComponent: () => import('@components/guides/measuresUnits/measures-units.component').then(c => c.MeasuresUnitsComponent),
        canActivate: [guardMeasureUnitsWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'measureunits/:id',
        loadComponent: () => import('@components/guides/measuresUnits/measure-details/measure-units-details.component').then(c => c.MeasureUnitsDetailsComponent),
        canActivate: [guardMeasureUnitsWatch],
        data: {
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/measureunits/'},
            ]
        }
    },
]
